import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';

const BravonRadioCheckbox = translate(({
    t,
    initialState,
    isDisabled,
    fieldType,
    fieldName,
    label, // Can be used for custom labels and accepts i18n locale keys as value
    hasHint,
    customStyles,
    wrapperCSSClasses,
    handleChange,
  }) => (
    <div className={`d-block m-0 ${wrapperCSSClasses || ''}`}>
      <label htmlFor={fieldName} className="row radio radial-rewards w-100 mb-1 ml-0">
        <div className="col p-0">
          <span className="radio__input" style={{ width: '1.4rem', height: '1.4rem', ...customStyles }}>
          <input
            id={fieldName}
            type={fieldType}
            name={fieldName}
            checked={initialState}
            onChange={e => handleChange(fieldName)(e.target.checked)}
            disabled={isDisabled}
          />
          <span className="radio__control" />
          </span>
        </div>

        <div className="col p-0">
          <span className="radio__label" style={{ color: '#2F2F3A' }}>
            {t(label) || t(`access_session.detail.${fieldName}`)}
          </span>
        </div>
      </label>

      {hasHint &&
        <div className="row radio w-100 mb-1 ml-0">
          <div className="col-auto p-0">
            {/* This next div exists only to maintain visual coherence */}
            <div
              className="can-be-deleted space-fixing-purpose"
              style={{ display: 'flex', width: '1.4rem', height: '1.4rem' }}
            />
          </div>

          <div className="col p-0">
            <p className="radio-hint">
              {t(`access_session.detail.${fieldName}.hint`)}
            </p>
          </div>
        </div>
      }
    </div>
  ));

BravonRadioCheckbox.propTypes = {
  initialState: PropTypes.bool,
  isDisabled: PropTypes.bool,
  fieldType: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  hasHint: PropTypes.bool,
  wrapperCSSClasses: PropTypes.string || null,
  customStyles: PropTypes.string || null,
  handleChange: PropTypes.func,
};
BravonRadioCheckbox.defaultProps = {
  initialState: false,
  isDisabled: false,
  fieldType: 'checkbox',
  hasHint: false,
  wrapperCSSClasses: null,
  customStyles: null,
};

export default BravonRadioCheckbox;
